/** 用户协议抽屉（→ 登录弹窗《用户协议》入口，叠在登录/找回密码弹窗之上） */
export const useAgreementNav = () => {
  const open = useState('agreement-drawer-open', () => false)

  const openAgreement = () => {
    open.value = true
  }

  const closeAgreement = () => {
    open.value = false
  }

  return { open, openAgreement, closeAgreement }
}
